// ShellFrame — wraps a routed page in the shared shell: the persistent Janet
// rail beside it on desktop, the condensed Janet bar above it on narrow
// widths, and a one-line preview notice. The OS's own navigation (sidebar,
// universal bar, block tabs, mobile bottom nav) stays exactly where the
// layout already puts it, so every module inherits the same navigation.
import { Link } from 'react-router-dom'
import { JanetRailDesktop, JanetRailCompact } from './JanetRail'
import { DemoTag } from './ui'

function PreviewNotice() {
  return (
    <div className="flex items-center gap-2 rounded-lg px-2.5 py-1 text-[11.5px] min-w-0" style={{ background: '#FBF1DD', border: '1px solid #EAD5AA', color: '#6d4a12' }}>
      <DemoTag>Shell preview</DemoTag>
      <span className="min-w-0 truncate">Home and Deals read your live records · other modules unchanged</span>
      <Link to="?shell=off" className="ml-auto shrink-0 font-semibold underline underline-offset-2">Leave</Link>
    </div>
  )
}

export default function ShellFrame({ children, mobile = false, showNotice = false }) {
  if (mobile) {
    return (
      <div className="flex flex-col" style={{ fontFamily: 'var(--ns-font-sans)' }}>
        <div className="flex flex-col gap-2 px-3 pt-2 pb-1">
          {showNotice && <PreviewNotice />}
          <JanetRailCompact />
        </div>
        {children}
      </div>
    )
  }
  return (
    // The Bridge (Aaron's sketch, 2026-10-01): the work in the middle, Janet on
    // the right edge of every page, the navy station rail on the left.
    <div className="flex flex-1 min-h-0" style={{ fontFamily: 'var(--ns-font-sans)' }}>
      <div className="flex-1 min-w-0 min-h-0 flex flex-col">
        <div className="shrink-0 flex flex-col gap-2 px-3 pt-2 lg:px-5 empty:hidden">
          {showNotice && <PreviewNotice />}
          <JanetRailCompact />
        </div>
        {children}
      </div>
      <JanetRailDesktop />
    </div>
  )
}
